import React from 'react';
import { Box, Typography } from 'components';
import SharedProfileCard from './SharedProfileCard';

const SharedFreelancerList = ({
  users = [],
  noUsersText = 'No freelancers found in this shared search.'
}) => {
  if (!users || users.length === 0) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" p={4}>
        <Typography>{noUsersText}</Typography>
      </Box>
    );
  }

  return (
    <Box className="shared-freelancer-list" flex={1} mb={0.5}>
      {users.map((user) => (
        <SharedProfileCard key={user.id} profileUser={user} />
      ))}
    </Box>
  );
};

export default SharedFreelancerList;
